function hasWindow() {
  return typeof window !== "undefined";
}
export {
  hasWindow
};
//# sourceMappingURL=has.js.map
